import { whiteLogo } from "../assets";

// Fires an OS-level notification (shows in the phone's notification tray /
// desktop notification center) so handover alerts are visible even when the
// CRM tab isn't focused. Requires the tab to still be open and running —
// notifying after the browser itself is fully closed needs Web Push
// (service worker + VAPID key + a backend endpoint to send the push), which
// is a separate, backend-involved feature.
export const showBrowserNotification = (title: string, body: string) => {
  if (typeof window === 'undefined' || !('Notification' in window)) return;

  const fire = () => {
    try {
      new Notification(title, { body, icon: whiteLogo });
    } catch {
      /* some browsers throw if not backed by a service worker registration */
    }
  };

  if (Notification.permission === 'granted') {
    fire();
  } else if (Notification.permission === 'default') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') fire();
    });
  }
};
